import axios, { AxiosResponse } from 'axios';
import { all, put, retry, takeLatest } from 'redux-saga/effects';

import {
  fetchOrderHistoryFailure,
  fetchOrderHistoryRequest,
  fetchOrderHistorySuccess,
} from './actions';
import { FETCH_ORDER_HISTORY_REQUEST } from './actionTypes';

// Order history sits on the critical path for the current-order tracking card,
// so a transient network/5xx blip shouldn't leave it permanently empty. Retry
// a few times with a short backoff before surfacing the failure.
const RETRY_ATTEMPTS = 3;
const RETRY_DELAY_MS = 1000;

const getOrderHistory = async (subscriptionId: number, shopifyCustomerId?: string) => {
  const params = shopifyCustomerId ? { shopify_customer_id: shopifyCustomerId } : {};
  return await axios.get<any>(`/api/v1/subscriptions/${subscriptionId}/order_history`, { params });
};

function* fetchOrderHistorySaga(action: ReturnType<typeof fetchOrderHistoryRequest>) {
  try {
    const response: AxiosResponse<any> = yield retry(RETRY_ATTEMPTS, RETRY_DELAY_MS, () =>
      getOrderHistory(action.payload.subscriptionId, action.payload.shopifyCustomerId),
    );

    yield put(
      fetchOrderHistorySuccess({
        orders: response.data,
      }),
    );
  } catch (e: unknown) {
    yield put(
      fetchOrderHistoryFailure({
        error: e instanceof Error ? e.message : 'Unknown error',
      }),
    );
  }
}

export function* ordersSaga() {
  yield all([takeLatest(FETCH_ORDER_HISTORY_REQUEST, fetchOrderHistorySaga)]);
}
